const reducer = (state=[], action)=>{
    if(action.type === 'historyDataReducers'){
     return action.value;
 }
     else return state;
 
 }
 
 export default reducer;